// extracted by mini-css-extract-plugin
module.exports = {"cancelledBox":"cancelled-box_cancelledBox__2nbHz"};